<template>
    <div v-if="list.length > 0" class="container full-device">
        <div id="hero" class="hero hero-boxed hero-boxed-slider">

            <div v-for="(val, index) in list" :key="index" class="item">
                <div class="item-wrap">
                    <div class="wrap">
                        <a class="item-bg" v-lazy:background-image="val.thumbnail" :href="val.url">
                            <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/1120x747.gif'" alt="">
                            <div class="label-box" v-if="val.is_sponsor"><span class="label label-sponsored">Sponsored</span></div>
                        </a>
                        <div class="item-content">
                            <div class="meta">
                                <div class="title"><a :href="val.url">{{ val.title }}</a></div>
                                <div class="date">{{ val.date }}</div>
                                <div class="category" v-html="val.dptag"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div><!-- end #hero -->
    </div>
</template>

<script>
import Vue from 'vue'
import jQuery from 'jquery'
import config from '@/../myconfig.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

window.jQuery = window.$ = jQuery
const myConfig = config

/* Import Jquery Plugins */
require('@/assets/theme/bkkmenu-2017/assets/js/slick/slick.min.js')
/* Import Jquery Plugins */

export default {
  name: 'HilightHero',
  mounted () {
    this.$nextTick(() => {
      var _slick = jQuery('.hero.hero-boxed-slider')
      var items = _slick.find('.item')
      var total = items.length

      _slick.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: true,
        responsive: [{
          breakpoint: 992,
          settings: {
            fade: false,
            arrows: false
          }
        }]
      })
    })
  },
  data: function () {
    return {
      list: window._hilight,
      THEME_PATH: myConfig.THEME_PATH
    }
  }
}
</script>
